import { validateNumberProperty, validateStringProperty } from '@/models/entities/type-utils';
import { AxiosError } from 'axios';
import { RESPONSE_CODE } from '@/constants/ApiConstants';
import { API_RESULT_TYPE } from '@/models/entities/api/api-result-type';

export default class ApiError {
  apiResultType: typeof API_RESULT_TYPE.ERROR;

  code: number;

  message: string;

  constructor(source: unknown) {
    this.apiResultType = API_RESULT_TYPE.ERROR;
    this.code = validateNumberProperty(source, 'code', false);
    this.message = validateStringProperty(source, 'message', false);
  }
}

export function makeApiError(code: number, message: string) {
  return new ApiError({ code, message });
}

export function getApiErrorFromResponse(error: AxiosError) {
  try {
    return new ApiError(error.response?.data);
  } catch (parseError) {
    console.error(parseError);
    return makeApiError(RESPONSE_CODE.CODE_GENERIC_ERROR, 'An unknown error occurred');
  }
}
